import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRouter from './AppRouter';
import { Provider } from 'react-redux';
import { store } from './redux/store';

const App = (): React.ReactElement => {
  return (
    <Router>
      <Provider store={store}>
        <AppRouter />
      </Provider>
    </Router>
  );
};

export default App;
